module.exports = __webpack_public_path__ + "static/media/mt-rainier-compressed.6e48025f.jpg";